import * as React from "react";

// NPM
import clsx from "clsx";
import { animated } from "react-spring";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Container, ContainerProps } from "@material-ui/core";

// Utility
import Utility from "../../domain/classes/Utility";

export const styles = (theme: Theme) =>
	createStyles({
		root: { padding: theme.spacing(2, 0) },
		flush: { padding: 0 },
	});

export interface SectionContainerProps extends ContainerProps {
	flush?: boolean;
}

const SectionContainer = React.forwardRef<
	HTMLDivElement,
	SectionContainerProps & WithStyles<typeof styles>
>(
	(
		{
			classes,
			className,
			children,
			flush,
			maxWidth = "xl",
			...containerProps
		},
		ref
	) => {
		return (
			<div className={clsx(classes.root, className)} ref={ref}>
				<Container
					maxWidth={maxWidth}
					{...containerProps}
					className={clsx(flush && classes.flush)}
				>
					{children}
				</Container>
			</div>
		);
	}
);

const StyledSectionContainer = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("SectionContainer"),
})(SectionContainer);

export default StyledSectionContainer;

export const AnimatedSectionContainer = animated(StyledSectionContainer);
